import mergeClassNames from "common/mergeClassNames";

// Can expand to accept more colors
export type IBadgeIndicatorColor = "red" | "green" | "yellow" | "default" | "blue";

interface IBadgeIndicatorProps {
    color?: IBadgeIndicatorColor;
    className?: string;
    children?: React.ReactNode;
}

export default function BadgeIndicator({ color, children, className }: IBadgeIndicatorProps) {
    return (
        <div
            className={mergeClassNames(
                "inline-flex h-6 items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
                !color || color === "default" ? "border-gray-200 bg-gray-100 text-gray-800" : "",
                color === "green" ? "border-green-200 bg-green-100 text-green-800" : "",
                color === "red" ? "border-red-200 bg-red-100 text-red-800" : "",
                color === "yellow" ? "border-yellow-200 bg-yellow-100 text-yellow-800" : "",
                color === "blue" ? "border-blue-200 bg-blue-100 text-blue-800" : "",
                className,
            )}
        >
            <div
                className={mergeClassNames(
                    "me-1 h-2 w-2 rounded-full",
                    !color || color === "default" ? "bg-gray-500" : "",
                    color === "green" ? "bg-green-500" : "",
                    color === "red" ? "bg-red-500" : "",
                    color === "yellow" ? "bg-yellow-500" : "",
                    color === "blue" ? "bg-blue-500" : "",
                )}
            ></div>
            <div className="indicator-text text-nowrap">{children}</div>
        </div>
    );
}
